import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-subscription-validate-dialog-box',
  templateUrl: './subscription-validate-dialog-box.component.html',
  styleUrls: ['./subscription-validate-dialog-box.component.scss']
})
export class SubscriptionValidateDialogBoxComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<SubscriptionValidateDialogBoxComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() { }

  // Method will execute when user clicks on close button
  close(): void {
    this.dialogRef.close({event:'close'});
  }

  // Method will execute when user clicks on ok button
  ok() {
    this.dialogRef.close({event:'ok'});
  }

  // Method will execute when user clicks on validate button
  validate() {
    this.dialogRef.close({event:'validate'});
  }

}
